import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const DetectionsWrapper = styled(FlexView)`
  flex-wrap: wrap;
  gap: 4px;
`;

export const Badge = styled(FlexView)`
  border-radius: 16px;
  padding: ${({ padding }) => padding || '4px 8px'};
  width: fit-content;
  background-color: ${({ bgColor }) => bgColor || COLORS.GREY_1};
`;
